var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("queries-table", {
        ref: "table",
        attrs: { url: _vm.indexUrl },
        scopedSlots: _vm._u([
          {
            key: "buttons",
            fn: function () {
              return [
                _c(
                  "el-tooltip",
                  {
                    attrs: {
                      content: "Vacuum",
                      placement: "top",
                      effect: "light",
                    },
                  },
                  [
                    _vm.canVacuum
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn-purple",
                            on: { click: _vm.showVacuumDialog },
                          },
                          [_c("i", { staticClass: "fas fa-broom" })]
                        )
                      : _vm._e(),
                  ]
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c("vacuuming-dialog", {
        ref: "vacuumDialog",
        attrs: { url: _vm.vacuumUrl },
        on: { vacuum: _vm.afterVacuum },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }